import React from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import Modal, { IModalChildProps } from '../../common/modal';
import '../../my-account/order-details/modals/modal-styles.css';

const Under18Modal = ({ onAccept, onClose }: IModalChildProps) => {
    const intl = useIntl();
    return (
        <Modal>
            <>
                <div className="modal-header">
                    <button
                        type="button"
                        className="close"
                        id="closeModalUnder18Modal"
                        data-dismiss="modal"
                        aria-label={intl.formatMessage({
                            id: 'Close',
                        })}
                        onClick={onClose}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <p className="text-center modal-spacing">
                    <FormattedMessage
                        id="We_may_need_to_change_model_size"
                        defaultMessage="We may need to change model or size due to anatomy restrictions."
                    />
                </p>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={onClose}
                    >
                        <FormattedMessage id="Close" defaultMessage="Close" />
                    </button>
                </div>
            </>
        </Modal>
    );
};

export default Under18Modal;
